import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
}), 'FormatItalic');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatItalic.js
// module id = 3849
// module chunks = 2